import React, { useEffect, useState, useMemo } from 'react'
// Ant design
// Mobx
import { inject, observer } from 'mobx-react'
import { Button, Comment, message, Modal } from 'antd'

import EmptyContent from '../../components/EmptyContent'
import { EmptyText } from '../../components/Common/CellText'

import TableComponent from '../../components/Common/TableComponent'

const ModalAssetPreView = props => {
  const {
    userStore,
    data,
    onCancel,
    setPreViewVisible,
    authenticationStore,
    loadingAnimationStore,
    fileStore,
  } = props

  const {
    userListPageIndex,
    userListPageSize,
    userListKeyword,
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
  } = userStore

  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)
      // userStore.setFilter('userListHasAdmin', true)
      userStore.setFilter(
        'companyCode',
        authenticationStore.currentCompanyCode()
      )
      userStore
        .getUserList()
        .finally(() => loadingAnimationStore.showSpinner(false))
    }
  }, [
    userListPageIndex,
    userListKeyword,
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
    loadingAnimationStore,
    userStore,
    authenticationStore.currentUser,
  ])
  const [checkErrorData, setCheckErrorData] = useState(false)

  useEffect(() => {
    if (Array.isArray(data?.data) && data.data.length === 0) {
      setCheckErrorData(true)
    }
    console.log("----- Data excel is :", data)
    if (Array.isArray(data?.data)) {
      data.data.forEach(info => {
        if (info.note !== '') {
          setCheckErrorData(true)
          return false
        }
      })
    }
  }, [data])

  const tableColumns = useMemo(
    () => [
      {
        title: 'STT',
        key: 'stt',
        render: record =>
          record.stt ? (
            <span>{record.stt}</span>
          ) : (
            <EmptyText>Không rõ</EmptyText>
          ),
      },
      {
        title: 'Loai dụng cụ, văn phòng phẩm',
        key: 'type',
        render: record =>
          record.type ? (
            <span>{record.type}</span>
          ) : (
            <EmptyText>Không rõ</EmptyText>
          ),
      },
      {
        title: 'Tên dụng cụ, văn phòng phẩm',
        width: 150,
        key: 'namedcVpp',
        render: record =>
          record.namedcVpp ? (
            <Comment
              author={
                <span style={{ textTransform: 'capitalize' }}>
                  {record.namedcVpp}
                </span>
              }
            />
          ) : (
            <EmptyText>Không rõ</EmptyText>
          ),
      },
      {
        title: 'Đơn vị tính',
        key: 'unit',
        width: 120,
        render: record =>
          record.unit ? record.unit : <EmptyText>Không rõ</EmptyText>,
      },
      {
        title: 'Thuế',
        key: 'tax',
        render: record =>
          record.tax ? (
            record.tax
          ) : (
            <EmptyText>Thuế</EmptyText>
          ),
      },
      {
        title: 'Đơn giá trước thuế',
        key: 'cost_before_tax',
        render: record =>
          record.cost_before_tax ? record?.cost_before_tax : <EmptyText>Đơn giá trước thuế</EmptyText>,
      },
      {
        title: 'Đơn giá sau thuế',
        key: 'cost_after_tax',
        render: record =>
          record.cost_after_tax ? record?.cost_after_tax : <EmptyText>Đơn giá sau thuế'</EmptyText>,
      },
      {
        title: 'Số lượng trong kho',
        key: 'remain_in_stock',
        render: record => record?.remain_in_stock,
      }
    ],
    []
  )

  const HandelCreateAsset = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await fileStore.createAssetsFromExcel(data.data)
      loadingAnimationStore.showSpinner(false)
      message.success('Đã tạo tài sản từ file Excel thành công.')
      setPreViewVisible(false)
    } catch (error) {
      loadingAnimationStore.showSpinner(false)
      console.error('Error importing Excel:', error)
      message.error('Đã xảy ra lỗi khi import tài sản từ file Excel.')
    }
  }

  return (
    <Modal
      visible={true}
      width={1200}
      title="Xem trước"
      onCancel={onCancel}
      style={{ top: 20 }}
      footer={[
        checkErrorData && (
          <span style={{ color: 'red', marginRight: '10px' }}>
            Yêu cầu sửa lại file theo đúng định dạng trước khi import
          </span>
        ),
        <Button danger ghost onClick={onCancel}>
          Quay lại
        </Button>,
        !checkErrorData && (
          <Button type="primary" onClick={HandelCreateAsset}>
            Nhập excel
          </Button>
        ),
      ]}>
      <TableComponent
        rowKey={record => record?.code}
        dataSource={data && data.data}
        columns={tableColumns}
        pagination={false}
        scroll={{ x: 1000 }}
        locale={{
          emptyText: <EmptyContent />,
        }}
      />
    </Modal>
  )
}

ModalAssetPreView.propTypes = {}

export default inject(
  'userStore',
  'userGroupStore',
  'authenticationStore',
  'loadingAnimationStore',
  'selectUserStore',
  'fileStore'
)(observer(ModalAssetPreView))
